import { FormlyFieldConfig } from "@ngx-formly/core";

export class ConcreteMaturityModelForm {
    fields: FormlyFieldConfig[];

    actionText = 'stages.button.new';

    constructor(translateService, dataProjects, dataCompanies, user, config?) {

      const companies: {value: string | null, label: string}[] = [];
      for(const company of dataCompanies) companies.push({value: company['_id'], label: company['name'] });

      const projects: {value: string | null, label: string}[] = [];
      for(const project of dataProjects) projects.push({value: project['_id'], label: project['name'] });

      this.fields = [
          {
              key: 'name',
              type: 'input',
              wrappers: ['default-wrapper'],
              props: {
              required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.name')
              }
          },
          {
              key: 'maturityMethod',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: 'nurse_saul',
              props: {
                required: true,
                options: [{label: 'Nurse-Saul', value: 'nurse_saul'}]
              },
              expressions: {
                'props.label': translateService.stream('fields.maturityMethod')
              }
          },
          {
              key: 'strengthMethod',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: 'plowman',
              props: {
                required: true,
                options: [{label: 'Plowman', value: 'plowman'}]
              },
              expressions: {
                'props.label': translateService.stream('fields.strengthMethod')
              }
          },
          {
              key: 'log',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: 'log_10',
              props: {
                required: true,
                options: [{label: 'log 10', value: 'log_10'}, {label: 'log e', value: 'log_e'}]
              },
              expressions: {
                'props.label': translateService.stream('fields.log')
              }
          },
          {
              key: 'A_VAL',
              type: 'input',
              wrappers: ['default-wrapper'],
              props: {
                type: 'number',
                required: true,
              },
              expressions: {
                'props.label': translateService.stream('fields.A_VAL')
              }
          },
          {
              key: 'B_VAL',
              type: 'input',
              wrappers: ['default-wrapper'],
              props: {
                type: 'number',
                required: true,
              },
              expressions: {
                'props.label': translateService.stream('fields.B_VAL')
              }
          },
          {
              key: 'ABS_TEMP',
              type: 'input',
              wrappers: ['default-wrapper'],
              props: {
                type: 'number',
                required: true,
              },
              expressions: {
                'props.label': translateService.stream('fields.ABS_TEMP')
              }
          },
          {
              key: 'company',
              type: 'select',
              wrappers: ['default-wrapper'],
              props: {
                options: companies,
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.company')
              }
          },
          {
              key: 'project',
              type: 'select',
              wrappers: ['default-wrapper'],
              props: {
                options: projects,
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.project')
              }
          },
          {
              key: 'specifications',
              type: 'chips-number',
              wrappers: ['default-wrapper'],
              props: {
                required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.specifications')
              }
          },
          {
              key: 'specifications_maturity',
              type: 'chips-number',
              wrappers: ['default-wrapper'],
              props: {
                required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.specifications_maturity')
              }
          },
          {
              key: 'specifications_maturity_relative',
              type: 'chips-number',
              wrappers: ['default-wrapper'],
              props: {
                required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.specifications_maturity_relative')
              }
          },
      ];
    }
}

export class EditConcreteMaturityModelForm {
  fields: FormlyFieldConfig[];
  model: {};
  actionText = 'button.save';

  constructor(translateService, currentValue, dataProjects, dataCompanies, user, config?) {

    const companies: {value: string | null, label: string}[] = [];
      for(const company of dataCompanies) companies.push({value: company['_id'], label: company['name'] });

      const projects: {value: string | null, label: string}[] = [];
      for(const project of dataProjects) projects.push({value: project['_id'], label: project['name'] });

      this.fields = [
          {
              key: 'name',
              type: 'input',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.name,
              props: {
              required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.name')
              }
          },
          {
              key: 'maturityMethod',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.maturityMethod,
              props: {
                required: true,
                options: [{label: 'Nurse-Saul', value: 'nurse_saul'}]
              },
              expressions: {
                'props.label': translateService.stream('fields.maturityMethod')
              }
          },
          {
              key: 'strengthMethod',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.strengthMethod,
              props: {
                required: true,
                options: [{label: 'Plowman', value: 'plowman'}]
              },
              expressions: {
                'props.label': translateService.stream('fields.strengthMethod')
              }
          },
          {
              key: 'log',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.log,
              props: {
                required: true,
                options: [{label: 'log 10', value: 'log_10'}, {label: 'log e', value: 'log_e'}]
              },
              expressions: {
                'props.label': translateService.stream('fields.log')
              }
          },
          // {
          //     key: 'A_VAL',
          //     type: 'input',
          //     wrappers: ['default-wrapper'],
          //     props: {
          //       type: 'number',
          //       required: true,
          //     },
          //     expressions: {
          //       'props.label': translateService.stream('fields.A_VAL')
          //     }
          // },
          // {
          //     key: 'B_VAL',
          //     type: 'input',
          //     wrappers: ['default-wrapper'],
          //     props: {
          //       type: 'number',
          //       required: true,
          //     },
          //     expressions: {
          //       'props.label': translateService.stream('fields.B_VAL')
          //     }
          // },
          // {
          //     key: 'ABS_TEMP',
          //     type: 'input',
          //     wrappers: ['default-wrapper'],
          //     props: {
          //       type: 'number',
          //       required: true,
          //     },
          //     expressions: {
          //       'props.label': translateService.stream('fields.ABS_TEMP')
          //     }
          // },
          {
              key: 'company',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.company,
              props: {
                disabled: !user.roles.includes('superadmin'),
                options: companies,
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.company')
              }
          },
          {
              key: 'project',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.project,
              props: {
                options: projects,
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.project')
              }
          },
          {
              key: 'specifications',
              type: 'chips-number',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.specifications,
              props: {
                required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.specifications')
              }
          },
          {
              key: 'specifications_maturity',
              type: 'chips-number',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.specifications_maturity,
              props: {
                required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.specifications_maturity')
              }
          },
          {
              key: 'specifications_maturity_relative',
              type: 'chips-number',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.specifications_maturity_relative,
              props: {
                required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.specifications_maturity_relative')
              }
          },
      ];
  }
}

export class LinkedConcreteMaturityModelForm {
    fields: FormlyFieldConfig[];

    actionText = 'button.save';

    constructor(translateService) {
      this.fields = [
          {
              key: 'name',
              type: 'input',
              wrappers: ['default-wrapper'],
              props: {
              required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.name')
              }
          },
          {
              key: 'maturityMethod',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: 'nurse_saul',
              props: {
                required: true,
                options: [{label: 'Nurse-Saul', value: 'nurse_saul'}]
              },
              expressions: {
                'props.label': translateService.stream('fields.maturityMethod')
              }
          },
          {
              key: 'strengthMethod',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: 'plowman',
              props: {
                required: true,
                options: [{label: 'Plowman', value: 'plowman'}]
              },
              expressions: {
                'props.label': translateService.stream('fields.strengthMethod')
              }
          },
          {
              key: 'log',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: 'log_10',
              props: {
                required: true,
                options: [{label: 'log 10', value: 'log_10'}, {label: 'log e', value: 'log_e'}]
              },
              expressions: {
                'props.label': translateService.stream('fields.log')
              }
          },
          {
            fieldGroupClassName: 'grid grid-cols-3 gap-4',
            fieldGroup: [
              {
                  key: 'A_VAL',
                  type: 'input-number',
                  wrappers: ['default-wrapper'],
                  props: {
                    required: true,
                  },
                  expressions: {
                    'props.label': translateService.stream('fields.A_VAL')
                  }
              },
              {
                  key: 'B_VAL',
                  type: 'input-number',
                  wrappers: ['default-wrapper'],
                  props: {
                    required: true,
                  },
                  expressions: {
                    'props.label': translateService.stream('fields.B_VAL')
                  }
              },
              {
                  key: 'ABS_TEMP',
                  type: 'input-number',
                  wrappers: ['default-wrapper'],
                  props: {
                    required: true,
                  },
                  expressions: {
                    'props.label': translateService.stream('fields.ABS_TEMP')
                  }
              },
            ]
          },
          {
              key: 'specifications',
              type: 'chips-number',
              wrappers: ['default-wrapper'],
              props: {
                required: false,
                suffix: ' MPa'
              },
              expressions: {
                'props.label': translateService.stream('fields.specifications')
              }
          },
          {
              key: 'specifications_maturity',
              type: 'chips-number',
              wrappers: ['default-wrapper'],
              props: {
                required: false,
                suffix: ' ºCd'
              },
              expressions: {
                'props.label': translateService.stream('fields.specifications_maturity')
              }
          },
          {
              key: 'specifications_maturity_relative',
              type: 'chips-number',
              wrappers: ['default-wrapper'],
              props: {
                required: false,
                suffix: ' ºCd'
              },
              expressions: {
                'props.label': translateService.stream('fields.specifications_maturity_relative')
              }
          },
      ];
    }
}

/**
 * f-user's own Concrete Model detail page (superadmin) edits only name + the three specification
 * checkpoint arrays. Operational calculation variables (A_VAL/B_VAL/ABS_TEMP/log/methods/
 * company/project) are deliberately non-editable here — a mis-entered value gets corrected
 * directly in the DB, not through this form, since editing them post-creation risks silently
 * invalidating an already-fitted model. Kept as its own form class rather than reusing
 * EditConcreteMaturityModelForm so f-user and f-admin's edit surfaces can diverge independently.
 */
export class EditLinkedConcreteMaturityModelForm {
    fields: FormlyFieldConfig[];

    actionText = 'button.save';

    constructor(translateService, currentValue) {
      this.fields = [
          {
              key: 'name',
              type: 'input',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.name,
              props: {
              required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.name')
              }
          },
          {
              key: 'specifications',
              type: 'chips-number',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.specifications,
              props: {
                required: false,
                suffix: ' MPa'
              },
              expressions: {
                'props.label': translateService.stream('fields.specifications')
              }
          },
          {
              key: 'specifications_maturity',
              type: 'chips-number',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.specifications_maturity,
              props: {
                required: false,
                suffix: ' ºCd'
              },
              expressions: {
                'props.label': translateService.stream('fields.specifications_maturity')
              }
          },
          {
              key: 'specifications_maturity_relative',
              type: 'chips-number',
              wrappers: ['default-wrapper'],
              defaultValue: currentValue.specifications_maturity_relative,
              props: {
                required: false,
                suffix: ' ºCd'
              },
              expressions: {
                'props.label': translateService.stream('fields.specifications_maturity_relative')
              }
          },
      ];
    }
}